(function CalendarIndex($, Adzuki)
{
	"use strict";
	
	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		// Calendar click
		$('.calendar-view').click(function calendarClick() {
			document.location = Adzuki.base_uri + '/CalendarSearchIndex/index/' + $(this).data('month') + '/' + $(this).data('year');
		});

		// Calendar list click
		$('.calendar-list-view').click(function calendarListClick() {
			document.location = Adzuki.base_uri + '/CalendarSearchIndex/listCalendar/' + $(this).data('month') + '/' + $(this).data('year');
		});

		Adzuki.onload('CalendarSearchIndex/listCalendar', function onload() {
			
			$("a.info-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text('Viewing Event');
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});
		});
	});

	// functions here

}(jQuery, window.Adzuki || {}));